
import { ADULT_STUDY_SERVER, API_COURSE_SERVER, API_SERVER, LOGIN_AUTH_URL, PAYMENT_SERVER, XBK_CONFIG, VIRTUALNUMBERSERVER } from '../config';

function generateParamsString(pathKey, params, useragent) {
  const userAgent = useragent || global.navigator.userAgent;
  const uaMatch = userAgent.match(/youdaodict\/([\d.]+)/);
  const keyFromParams = uaMatch && uaMatch[1] ? { keyfrom: `deskdict.${uaMatch[1]}` } : {};
  const param = Object.assign({}, {
    api_ver: '1.10.0',  // tab服务版本参数
    api_version: '1.2', // 主站服务版本参数
    t: new Date().getTime(),
  }, params, keyFromParams);
  if (global.debug) param.preview = true
  let string = Object.keys(param).reduce((memo, key) =>
    `${memo}${key}=${param[key]}&`
    , '').slice(0, -1)
  if (pathKey.indexOf('?') !== -1) {
    string = `${pathKey}&${string}`
  } else {
    string = `${pathKey}${string ? '?' : ''}${string}`
  }
  // console.log(string)
  // if (!process.env.BROWSER) {
  //   return string.match(/^http(s)?:/) ? string : `${API_SERVER}${string}`;
  // }
  return string.match(/^http(s)?:/) ? string : `${API_SERVER}${string}`
}


function dsCreator({ fetch, history, originParams, sessionData }) {
  const request = (pathKey, params) => {
    const req = fetch(generateParamsString(pathKey, Object.assign(
      {}, params, originParams)))
    return req.then((res) => {
      // console.log(res.headers.get('set-cookie'))
      // console.log(sessionData)
      // eslint-disable-next-line no-param-reassign
      if (sessionData) sessionData.cookie = res.headers.get('set-cookie')
      return res
    })
  }

  const allRequests = {

    // 获取首页数据（ke.youdao.com/course3/api/webhome)
    home: () => request('webhome'),

    // 首页加载更多
    homeMore: tagIds => request('webhome/recommendCourse', {
      tagIds: `[${tagIds.join(',')}]`,
    }),

    // 首页是否展示协议
    homeNeedWindow: () => request(`${API_COURSE_SERVER}nichijou/pop/needwindow`),
    // 首页 签署协议
    homeSigningAgreement: status => request(`${API_COURSE_SERVER}nichijou/pop/commitwindow?commitStatus=${status}`),

    // 用户登录
    login: (cf, tp) => request(`${LOGIN_AUTH_URL}/login?app=web&product=DICT&tp=${tp}&cf=${cf}&newjson=true&version=2.0`),
    // 退出登陆
    loginOut: () => request(`${LOGIN_AUTH_URL}/se/reset?product=DICT&app=ke&newjson=true&version=2.0`),
    // 用户登录后信息
    fetchLoginInfo: () => request(`${LOGIN_AUTH_URL}/co/cq?product=DICT&cf=1&newjson=true&version=2.0`),
    // 账单中是否存在订单(登陆后判断是否需要跳绑定页用)
    containCourse: () => request(`${API_COURSE_SERVER}course/api/user/order/contains`),
    // 用户手机账号绑定
    bindMobile: () => request(`${LOGIN_AUTH_URL}/bind/special/bind?product=DICT&appname=ke&newjson=true&version=2.0`),
    // 强制用户手机账号绑定
    forceBindMobile: () => request(`${LOGIN_AUTH_URL}/bind/special/forceBind?product=DICT&appname=ke&newjson=true&version=2.0`),
    // 更新用户手机账号绑定
    updateBindMobile: () => request(`${LOGIN_AUTH_URL}/bind/changephone?product=DICT&appname=ke&newjson=true&version=2.0`),
    // 用户手机账号解绑定, 未使用
    unbindMobile: () => request(`${LOGIN_AUTH_URL}/bind/unbindphone?product=DICT&appname=ke&newjson=true&version=2.0`),
    // 用户虚拟账号设置
    virtualMobileTest: mobile => request(`${VIRTUALNUMBERSERVER}checkMobile?mobile=${mobile}`),


    // 用户信息
    userStatus: () => request(`${API_COURSE_SERVER}api/user_status.jsonp`),
    userRemind: () => request(`${API_COURSE_SERVER}course/remind.json`),
    cancelRemind: hash => request(`${API_COURSE_SERVER}course/remind.json`, {
      hash,
    }),

    // 垂直页初始化
    tag: (id, ptag) => request('vertical2', {
      tag: id,
      ptag: ptag || '',
      api_ver: '2.8',
    }),

    // 垂直页加载更多
    tagMore: (tag, rank) => request('content/course', {
      tag,
      rank,
    }),

    // 我的课程初始化
    mycourse: (param, pageNum = 1) => request(`${API_COURSE_SERVER}course/app/mycoursev3.json${param || '?&courseStatus=unexpire'}&page=${pageNum}`),

    // 我的课程-云课堂的课程初始化
    mycourseStudy: (param, pageNum = 1) => request(`${ADULT_STUDY_SERVER}course/app/mycoursev3.json${param || '?&courseStatus=unexpire'}&page=${pageNum}`),

    // 我的订单
    myOrder: (offset = 0) => request(`${PAYMENT_SERVER}myOrder.json`, {
      offset,
      api_version: '1.14',
    }),
    // 迁移云课堂的成人订单
    adultOrder: (offset = 0) => request(`${ADULT_STUDY_SERVER}course/app/myOrder.json`, {
      offset,
    }),
    // 取消订单
    cancelOrder: orderId => request(`${API_COURSE_SERVER}api/order/cancel.json`, {
      orderid: orderId,
    }),
    // 问卷调查 0：支付成功 1:取消订单  http://luna.corp.youdao.com/index.php?title=%E5%AD%A6%E5%A0%82APP%E9%97%AE%E5%8D%B7%E8%B0%83%E6%9F%A5%E6%8E%A5%E5%8F%A3
    survey: (surveyType = 1) => request(`${API_COURSE_SERVER}api/survey/get.jsonp`, { surveyType }),
    surveySubmit: (surveyType = 1, surveyId, choice) => request(`${API_COURSE_SERVER}api/survey/submit.jsonp`, {
      surveyType,
      surveyId,
      choice,
    }),
    // 根据订单ID查询物流信息
    getLogisticByOrderId: orderId => request(`${API_COURSE_SERVER}course/app/order/logistics.json?orderId=${orderId}`),

    // 课程详情页
    courseDetail: courseId => request(`${API_COURSE_SERVER}course/api/detail.json?courseId=${courseId}`),

    courseComment: (params, isHistory) => {
      const commentUrl = isHistory ?
        `${API_COURSE_SERVER}api/comment/history.jsonp` :
        `${API_COURSE_SERVER}api/comment/list.jsonp`
      return request(commentUrl, params)
    },

    order: id => request(`${PAYMENT_SERVER}order/detail.json`, {
      id,
    }),
    orderSubmit: (orderId, payType) => request(`${PAYMENT_SERVER}orderSubmit.json`, {
      orderId,
      payType,
    }),

    historyResult: item => request('search', {
      q: encodeURIComponent(item),
      start: 0,
      offset: 20,
    }),

    historyResultMore: (item, start) => request('search', {
      q: encodeURIComponent(item),
      start,
      offset: 20,
    }),

    searchSuggest: item => request('suggest', {
      n: 5,
      q: item,
    }),
    // 组合卡片系列课程详情
    serialCourse: params => request('content/serialcourse', {
      api_ver: '2.5',
      ...params,
    }),

    // 通过课程 id 取系列课
    serial: courseIds => request('content/cards', {
      courseIds,
    }),

    // 支付相关
    // 继续支付
    payContinue: (orderId, payType) => request(`${API_COURSE_SERVER}course/app/orderSubmit.json`, {
      orderId,
      payType,
      payClient: 'WEB',
      wxTradeType: payType === 'wechat' ? 'NATIVE' : null,
    }),

    // 订单相关
    // 微信wap支付轮询订单状态
    orderInfo: orderId => request(`${API_COURSE_SERVER}api/order/info/${orderId}.jsonp`),

    // 优惠券套餐: 套餐支持优惠券
    couponCoursePackage: packageIds => request('package/cards', {
      packageIds,
    }),

    xbkVersion: () => request(`${XBK_CONFIG}getConfig`),
    // 获取热词
    getHotWords: tag => request('hotwords/tag', {
      tag,
      api_ver: '2.8',
    }),
  }

  return {
    ds: allRequests,
    history,
  }
}

export default dsCreator



// WEBPACK FOOTER //
// ./src/store/createHelpers.js